
define('apiController',['jquery', 'rmlibrary/promise', 'config'], function($, Promise, config) {
    return {
        getPromotions: function() {
            return new Promise(function(resolve, reject) {
                $.ajax({
                        url: config.APIUrl,
                        cache: false,
                        data: {
                            language: (config.lang === 'fr') ? 'fr' : 'en',
                            page: 1,
                            per_page: 1000,
                            api_key: config.api_key
                        }
                    })
                    .done(function(res) { resolve(res); })
                    .fail(function(jqXHR, textStatus, errorThrown) { reject(errorThrown); });
            });
        }
    };
});

